import React, { useEffect, useState } from "react";
import { api, CLIENTS as FALLBACK } from "@/lib/config";
import { useT } from "@/lib/i18n";

export default function ClientsMarquee({ inverse = true }) {
  const t = useT();
  const [clients, setClients] = useState(FALLBACK);
  useEffect(() => {
    api.get("/clients")
      .then(({ data }) => { if (Array.isArray(data) && data.length > 0) setClients(data); })
      .catch(() => {});
  }, []);

  const items = [...clients, ...clients];

  return (
    <section
      data-testid="clients-marquee"
      className={`py-16 md:py-24 overflow-hidden ${inverse ? "bg-brand-deep text-white" : "bg-paper-2 text-ink"}`}
    >
      <div className="max-w-[1600px] mx-auto px-6 md:px-12 lg:px-16 mb-10 flex items-end justify-between">
        <p className="section-num" style={{ color: inverse ? "#E62C86" : undefined }}>{t("common.referenced")}</p>
        <p className={`text-xs uppercase tracking-[0.3em] hidden md:block ${inverse ? "text-white/85" : "opacity-50"}`}>
          {t("common.referencedSub")}
        </p>
      </div>
      <div className="relative">
        <div className="marquee-track items-center">
          {items.map((c, i) => (
            <div
              key={i}
              data-testid={`client-${(c.name||'').replace(/\s+/g, '-').toLowerCase()}`}
              className="flex items-center justify-center h-28 md:h-32 px-16 md:px-20 shrink-0"
              title={c.name}
            >
              <img
                src={c.logo}
                alt={c.name}
                className="client-logo h-20 md:h-24 w-auto max-w-[220px] object-contain"
                onError={(e) => { e.currentTarget.outerHTML = `<span class="display text-2xl text-white/80 italic">${c.name}</span>`; }}
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
